/**
 * Type-based stacking for map markers. Leaflet stacks markers by screen-y
 * (southern markers render above northern ones), which buried the trafo
 * loading badge under neighbouring house/KVS markers when several elements
 * pile up at close zoom (EWH feedback). The offsets are deliberately modest:
 * they decide the order inside a local pile but do not override the natural
 * screen order across the whole viewport. Selection stays on top of
 * everything nearby.
 */
export function markerZIndexOffset(elementType: string, isSelected: boolean): number {
  const typeOffset =
    elementType === 'trafostation' ? 600
      : elementType === 'kabelverteilschrank' ? 400
        : elementType === 'hausanschluss' ? 200
          : 0;
  return (isSelected ? 1000 : 0) + typeOffset;
}
